import { newSpecialistRepository } from "@/repositories/specialist";
import { client } from "@/api/client";
import { Specialist } from "@/types/specialist";
import { Breadcrumb } from "@/components/base/Breadcrumb";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { Head } from "@/components/base/Head";
import { ScrollToTop } from "@/components/base/ui/ScrollToTop";

const SpecialistsPage = ({ specialists }: { specialists: Specialist[] }) => {
  const META_TITLE = "講師紹介";
  const META_DESCRIPTION =
    "中小企業の戦略ラボの講師をご紹介します。中小企業の戦略ラボの講師は、年間で経営相談件数300件以上、事業計画・経営計画策定支援件数100件以上の実績を残し、総合的な経営支援・伴走支援で高い評価を獲得するエキスパート。豊富なノウハウと実績で、貴社の組織と社員の成長を促します。";
  const breadcrumbs = [
    {
      title: META_TITLE,
    },
  ];
  return (
    <>
      <Head
        title={META_TITLE}
        canonicalPath={"/specialists"}
        description={META_DESCRIPTION}
      />
      <main className={"pb-20"}>
        <div className={"bg-[#0D1D47] py-10 px-5 text-center"}>
          <h1 className={"text-white text-3xl font-bold"}>{META_TITLE}</h1>
        </div>
        <div className={"mb-10 max-w-[1440px] m-auto px-4 py-2"}>
          <Breadcrumb breadcrumbs={breadcrumbs} />
        </div>
        <div className={"max-w-[960px] px-5 m-auto"}>
          <h2
            className={
              "text-[#0D1D47] text-2xl font-bold flex items-center mb-10"
            }
          >
            <span className={"relative w-1 h-14 mr-4"}>
              <span className={"block h-full bg-[#0D1D47]"} />
              <span
                className={
                  "block h-1/2 w-full bg-blue-400 absolute top-1/2 left-0"
                }
              />
            </span>
            講師一覧
          </h2>
          <div className={"grid grid-cols-2 md:grid-cols-4 gap-3"}>
            {specialists.map((specialist, index) => (
              <div key={index}>
                <Link
                  href={`/specialists/${specialist.slug}`}
                  className={"hover:opacity-20"}
                >
                  <Image
                    src={specialist.image}
                    width={200}
                    height={200}
                    objectFit={"cover"}
                    alt={""}
                  />
                  <p className={"text-sm mb-1"}>{specialist.company}</p>
                  <p className={"font-bold text-xl"}>
                    {specialist.last_name_ja} {specialist.first_name_ja}
                  </p>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <ScrollToTop />
      </main>
    </>
  );
};

export async function getStaticProps() {
  const specialistsRepository = newSpecialistRepository(client);
  try {
    const response = await specialistsRepository.listSpecialists();
    return {
      props: {
        specialists: response,
      },
    };
  } catch (e) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false,
      },
    };
  }
}
export default SpecialistsPage;
